import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthenticatorService {
  private readonly oidcService = inject(OidcSecurityService);

  private readonly authState = toSignal(this.oidcService.isAuthenticated$);

  private readonly userData = toSignal(this.oidcService.userData$);

  readonly isAuthenticated = computed(() => this.authState()?.isAuthenticated ?? false);

  readonly userName = computed(() => {
    const data = this.userData()?.userData as Record<string, string> | null;
    return data?.['name'] ?? data?.['preferred_username'] ?? data?.['email'] ?? '';
  });

  checkAuth(): void {
    this.oidcService.checkAuth().subscribe(({ isAuthenticated }) => {
      if (!isAuthenticated) {
        this.login();
      }
    });
  }

  login(): void {
    this.oidcService.authorize();
  }

  navigateTo(url: string): void {
    globalThis.location.href = url;
  }

  logout(): void {
    if (globalThis.sessionStorage) {
      globalThis.sessionStorage.clear();
    }
    this.oidcService.logoffLocal();

    const logoutUrl = environment.auth.logoutUrl;
    const clientId = environment.auth.clientId;
    const redirectUrl = globalThis.location.origin;

    this.navigateTo(`${logoutUrl}?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(redirectUrl)}`);
  }
}
